export default function Contato() {
  return (
    <div id="container" style={{ paddingTop: '2em', paddingLeft: '2em' }}>
      <img src="images/mainengine_2015_logo_comprido.jpg"
        style={{ position: 'relative', left: '4px', width: '692px', height: 'auto', zIndex: 1, textAlign: 'left' }} />
      <div id="wb_Text8" style={{ position: 'relative', left: '4px', top: '7px', width: '143px', height: '27px', zIndex: 0, textAlign: 'left' }}>
        <div id="wb_Text9" style={{ position: 'relative', left: '4px', width: '692px', height: '73px', zIndex: 1, textAlign: 'left' }}>
          <h2 className="titulo2">Contatos</h2>
          <hr id="Line10" />
          <br />
          <div><span className="linha_texto"><b>Escritório</b></span></div>
          <div><span className="linha_texto">Av. embaixador Abelardo Bueno nº 1, sala 618-A</span></div>
          <div><span className="linha_texto">Jacarepaguá - Barra Olímpica - Rio de Janeiro - RJ</span></div>
          <div><span className="linha_texto">Cep: 22775-022</span></div>
          <div><span className="linha_texto">(21) 3854-9802</span></div>
          <br />
          <div><span className="linha_texto"><b>Marcos Mesquita</b></span></div>
          <div><span className="linha_texto">Email: marcos.mesquita@mainengine.com.br</span></div>
          <div><span className="linha_texto">tel:(21) 97526-5884</span></div>
          <br />
          <div><span className="linha_texto"><b>Marcos Ronnie</b></span></div>
          <div><span className="linha_texto">Email: ronnie@mainengine.com.br</span></div>
          <div><span className="linha_texto">Tel:(21) 99770-7272</span></div>
        </div>
      </div>
      <div style={{ width: '100%', paddingTop: '40em' }}>
        <iframe 
          width="100%" 
          height="400" 
          frameBorder="0" 
          scrolling="no" 
          marginHeight={0} 
          marginWidth={0} 
          src="https://maps.google.com/maps?width=100%25&height=400&hl=en&q=Av.%20embaixador%20Abelardo%20Bueno%20n%C2%BA%201+(Mainengine%20Consultoria%20em%20Sistemas%20)&t=&z=14&ie=UTF8&iwloc=B&output=embed"
          title="Localização Mainengine"
        />
      </div>
    </div>
  )
}
